import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import classes from './modals.module.scss';
import MainButton from '../../../../common/buttons/MainButton';
import { tneAxiosClient } from '../../../../../api/apiSettings';
import { APPROVE_ALL_EXPENSES_COUNT } from '../../../../../utils/constants';

function SavedPopUp() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{t('dashboard.timesheet.savedmessage')}</p>
      <MainButton rounded forceWidth="244px" action={() => navigate('/dashboard/create-timesheet')}>
        {t('dashboard.timesheets.newbuttontxt')}
      </MainButton>
      <MainButton rounded outlined forceWidth="244px" action={() => navigate('/dashboard/timesheets')}>
        {t('dashboard.timesheet.gotodashboard')}
      </MainButton>
    </div>
  );
}

function UnsavedChanges({ saveHandler, closeHandler, rejectPreventing }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [canClose, setCanClose] = useState(false);

  useEffect(() => {
    if (canClose) navigate('/dashboard/timesheets');
  }, [canClose]);

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{t('dashboard.timesheet.unsavedmessage')}</p>
      <div className={classes.actionContainer}>
        <MainButton
          rounded
          outlined
          forceWidth="164px"
          action={() => {
            rejectPreventing(false);
            setCanClose(true);
          }}
        >
          {t('common.general.discard')}
        </MainButton>
        <MainButton
          rounded
          forceWidth="164px"
          action={() => {
            saveHandler();
            closeHandler();
          }}
        >
          {t('common.general.save')}
        </MainButton>
      </div>
    </div>
  );
}

function DeletePopUp({ deleteHandler, closeHandler }) {
  const { t } = useTranslation();

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{t('dashboard.timesheet.deletemessage')}</p>
      <MainButton rounded forceWidth="244px" action={deleteHandler}>
        {t('common.general.delete')}
      </MainButton>
      <MainButton rounded outlined forceWidth="244px" action={closeHandler}>
        {t('common.general.back')}
      </MainButton>
    </div>
  );
}

function ApproveAllFinalModal({ message, closeHandler, refresh }) {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{message}</p>
      <MainButton
        rounded
        outlined
        forceWidth="244px"
        action={() => {
          refresh();
          setSearchParams({ status: 'Pending' });
          closeHandler();
        }}
      >
        {t('dashboard.timesheet.gotodashboard')}
      </MainButton>
    </div>
  );
}
function FinalModal({ message, isTimesheet = true, queryParams }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [id, setId] = useState(null);

  const getNextDashboardId = async () => {
    try {
      const response = await tneAxiosClient.get(
        `v1/get-${isTimesheet ? 'timesheets' : 'expenses'}-by-approverId/?userId=${localStorage.getItem(
          'UserId'
        )}&Status=Pending`
      );

      if (response.data.Data?.[0]?.Id) {
        setId(response.data.Data[0].Id);
      }
    } catch (e) {
      setId(null);
    }
  };

  useEffect(() => {
    getNextDashboardId();
  }, []);

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{message}</p>
      {id && (
        <MainButton
          rounded
          forceWidth="244px"
          action={() => navigate(`/dashboard/${isTimesheet ? 'timesheet' : 'expense'}/${id}`)}
        >
          {isTimesheet ? t('dashboard.timesheet.nexttimesheet') : t('dashboard.expenses.nextexpense')}
        </MainButton>
      )}
      <MainButton
        rounded
        outlined
        forceWidth="244px"
        action={() => navigate(`/dashboard/${isTimesheet ? 'timesheets' : 'expenses'}${queryParams}`)}
      >
        {t('dashboard.timesheet.gotodashboard')}
      </MainButton>
    </div>
  );
}

function ConfirmationModal({ pendingTandECounts, confirm }) {
  const { t } = useTranslation();

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>
        {t('dashboard.timesheet.approveallconfirmation')}
        {pendingTandECounts?.PendingClaimsCount > APPROVE_ALL_EXPENSES_COUNT
          ? APPROVE_ALL_EXPENSES_COUNT
          : pendingTandECounts?.PendingClaimsCount}
        {t('dashboard.timesheet.claims')}
      </p>
      <MainButton rounded forceWidth="244px" action={confirm}>
        {t('common.general.approve')}
      </MainButton>
    </div>
  );
}

function RejectModal() {
  const { t } = useTranslation();

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{t('dashboard.timesheet.rejectmessagereq')}</p>
    </div>
  );
}

export { SavedPopUp, UnsavedChanges, DeletePopUp, ApproveAllFinalModal, FinalModal, ConfirmationModal, RejectModal };
